<template>
    <div class="home-page">
        <div class="page-header">
            <div class="header-logo"> 
                <div class="logo"></div> 
                <p class="title">中医药大健康智能服务平台</p>
            </div>
            <ul class="header-nav">
                <li v-for="(item,index) in headerNav" :key="index">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link nav-txt">
                            {{item.value}} 
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="list" v-for="(list,num) in item.children" :key="num">{{list.value}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </div>
        <div class="page-info home">
            <div class="info">
                <div class="info-right home-info">
                    <div class="right-list">
                        <div class="list">
                            <ul class="level-one">
                                <li class="animated" :class="[
                                    listActive==item.type?'active pulse ':'',
                                    item.type==1?'list-level1':'',
                                    item.type==2?'list-level2':'',
                                    item.type==3?'list-level3':'',
                                    item.type==4?'list-level4':'',
                                ]" 
                                    @click="list_tab(item)"
                                    @mouseenter="handleMouseEnter"
                                    @mouseleave="handleMouseLeave"

                                    v-for="item in infoList" :key="item.type">
                                    {{item.value}} 
                                    <div class="icon-arrow animated-all tada"></div>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                    <ul class="level-two" >
                        <li class="animated" :class="[ 
                            index==0?'level1':'',
                            index==1?'level2':'',
                            index==2?'level3':'',
                            index==3?'level4':'',
                        ]"
                        @mouseenter="handleMouseEnter"
                        @mouseleave="handleMouseLeave"
                        @click="levelTwo_clcik(item)"
                        v-for="(item,index) in levelTwoList" :key="index" v-html='item.value'></li>
                    </ul>
                </div>
            </div>
        </div>
        <footerPage></footerPage>
    </div>
</template>

<script> 
import homeData from './home_page/page_data.js'
import footerPage from './home_page/home_footer.vue'
export default {
    components: {
        footerPage,
    },
    data () {
        return {

            navIndex:1,
            listActive:1,
            infoList:homeData.infoList,
            levelTwoList:[],
            headerNav:homeData.headerNav,
            loadingIndex:1,
            loadingType:homeData.loadingType,
            userName:'',
            password:'',
            timer: null  

        }
    },
    mounted () {
        this.levelTwoList = this.infoList[0].children;
        this.periodic()
    },
    methods: {
        handleCommand(command) {
            this.levelTwo_clcik(command)
        },
        list_tab(item){
            this.listActive = item.type;
            this.levelTwoList = item.children;
        },
        periodic(){
            this.timer=setInterval(() => {
                // console.log(this.listActive)
                this.listActive++;
                if(this.listActive>4){
                    this.listActive=1; 
                } 
                this.levelTwoList = this.infoList[this.listActive-1].children;
            }, 5000);
        },
        levelTwo_clcik(item){ 
            let url=''
            console.log(item)
            if(item&&item.url){
                url=item.url; 
            }else if(item&&item.path){
                let routeUrl = this.$router.resolve({
                    path: item.path, 
                });
               url=routeUrl.href
            }
            if(!url)return
            window.open(url, "_blank");
        },
        handleMouseEnter() { 
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        handleMouseLeave() {
            this.periodic()
        }
    }
}
</script>

<style lang="less">
    @import url('../css/animated.less');
    @import url('../css/home_page.less');
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-duration: var(--animate-duration);
        animation-duration: var(--animate-duration);
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
    } 
</style>
<style lang="less" scoped>
.el-dropdown-menu__item, .el-menu-item{
        font-size: 16px;
        line-height: 40px;
    }
</style>